"use client"

// DOP-925: khởi tạo Tracking SDK — flush listeners + auto page_view theo pathname.
// Render trong AppLayoutWrapper (return null, không ảnh hưởng UI).
import { initTrackingFlushListeners, track } from "@/lib/tracking"
import { usePathname } from "next/navigation"
import { useEffect } from "react"

const TrackingProvider = () => {
  const pathname = usePathname()

  useEffect(() => {
    initTrackingFlushListeners()
  }, [])

  useEffect(() => {
    // page_view mỗi lần đổi route (SPA navigation) + lần load đầu
    track('page_view', { pathname })
  }, [pathname])

  return null
}

export default TrackingProvider
